<!--
 * @Author: LiuMouLiang
 * 手机端地址打开
import mobileUrl from '_c3/product/mobile-url.vue'
this.$refs.mobileUrl.open(url)
-->
<template>
    <tips-dialog
        ref="tipsDialog"
        v-model="isShow"
        :top="top"
        :max-height="false"
        width="502px">
        <div class="iframe-h5-wraper">
            <iframe :src="url" v-if="url" :style="{height:height}"></iframe>
        </div>
    </tips-dialog>
</template>

<script>
import tipsDialog from '_c3/tips/tips-dialog.vue';
export default {
    name: 'mobileUrl',
    props: {
        top: {
            type: String,
            default: '10vh'
        },
        height: {
            type: String,
            default: '70vh'
        }
    },
    data() {
        return {
            isShow: false,
            url: ','
        }
    },
    methods: {
        open(url){
            if(!url) return false;
            this.url = url;
            setTimeout(()=>{
                this.isShow = true;
            },300);
        },
    },
    created(){
    },
    components: { tipsDialog },
    computed: {},
}
</script>



// WEBPACK FOOTER //
// src/components_v3/product/mobile-url.vue